import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { FaChevronDown } from "react-icons/fa6";

const Dropdown = ({ title, items, value, onSelect }) => {
  return (
    <Menu as="div" className="relative inline-block">
      <MenuButton className="inline-flex w-full justify-center gap-x-2 rounded-xl border border-slate-300 bg-white px-5 py-2 text-base font-semibold text-slate-700 transition hover:border-slate-400 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:border-slate-500">
        { title }
        <FaChevronDown aria-hidden="true" className="mt-1 size-3 text-slate-500 dark:text-slate-400" />
      </MenuButton>

      <MenuItems transition modal={false}
        className="absolute right-0 z-10 mt-4 w-48 origin-top-right rounded-md border border-slate-300 bg-white shadow-lg outline-none transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in dark:border-slate-600 dark:bg-slate-800"
      >
        <div className="py-1">
          { items.map((item) => (
            <MenuItem
              key={item.id} as="button" type="button"
              onClick={() => onSelect?.(item)}
              className={`block w-full px-4 py-2 text-left text-base font-semibold outline-none transition hover:bg-slate-100 dark:hover:bg-slate-700 ${
                value === item.id ? "text-brand-orange" : "text-slate-700 dark:text-slate-300"
              }`}
            >
              { item.label }
            </MenuItem>
          ))}
        </div>
      </MenuItems>
    </Menu>
  )
};

export default Dropdown;